import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import BoxPayGrid from "../BoxPayGrid";
import { allTransactionschema } from "./allTransactionSchema";
import { refundSchema } from "./refundSchema";
import { useAuth } from "../../context/API_Client";
import InputSearch from "../inputSearch";
import Filter from "../filters/filter";
import { filterAllSchema } from "../filters/filterForAll/filterAllSchema";
import { filterRefundSchema } from "../filters/filterForRefund/filterRefundSchema";
import { filterVoidSchema } from "../filters/filterForVoidCapture/filterVoidSchema";
import AllTransactionButton from "../buttons/AllTransactionButton";
import "./transactionPage.css";
import "../analytics/analytics.css";
import InputSearchRefund from "../inputSearchRefund";
import "react-toastify/dist/ReactToastify.css";
import { fortmatTimezoneToUTC, PAGE_LIST } from "../utils/utils";
import LoadingLogoPage from "../loadingPage/loadingPage";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import OrderManagementContext from "../../context/orderManagement.context";
import { colorBrandObject } from "../../../constants/brandings";

const FIXED_OPERATION_NAME = ["Authorisation", "Sale", "Capture", "Partial_Capture", "Cancel", "PreDebitNotification"]

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const subtractMonths = (date, months) => {
  date.setMonth(date.getMonth() - months);
  return date;
};

function Transactions(operationPermissions) {
  const {
    getPaymentMethod,
    getRefundData,
    getVoidCaptureData,
    getAllTransactionDetails,
    getAllModalData,
    getAllPspConfigs,
    getAllPaymentMethods,
    merchantSettings,
    postPspConfigForFiltering,
    getAllVisualizationFilterData
  } = useAuth();
  const { setFilters } = useContext(OrderManagementContext);
  const [paymentMethodData, setPaymentMethodData] = useState([]);
  const [processorData, setProcessorData] = useState([]);
  const [refundData, setRefundData] = useState([]);
  const [withSearchbarModalData, setWithSearchbarModalData] = useState([]);
  const [withSearchbarModalDataForRefund, setWithSearchbarModalDataForRefund] = useState([]);
  const [dateModalData, setDateModalData] = useState([]);
  const [dateModalDataForRefund, setDateModalDataForRefund] = useState([]);
  const [filterApiData, setFilterApiData] = useState([]);
  const [formattedApiData, setFormattedApiData] = useState([])
  const [value, setValue] = useState(0);
  const [paymentError, setPaymentError] = useState([]);
  const [timezone, setTimezone] = useState("");
  const [loader, setLoader] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loaderForRefund, setLoaderForRefund] = useState(true);
  const [attributeName, setAttributeName] = useState("");
  const [attributeValue, setAttributeValue] = useState("");
  const transactionCurrentSearchAttribute = useRef({})
  const refundCurrentSearchAttribute = useRef({})
  const [businessUnitData, setBusinessUnitData] = useState(null);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageLimit, setPageLimit] = useState(PAGE_LIST[2]);
  const [totalDataCount, setTotalDataCount] = useState(100);
  // pagination

  useEffect(() => {
    const storedValue = sessionStorage.getItem("orderManagementTab");
    if (storedValue) {
      setValue(parseInt(storedValue));
    }
    getPaymentMethod(
      function (data) {
        setPaymentMethodData(data);
      },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
      }
    );
  }, []);

  useEffect(() => {
    sessionStorage.setItem("orderManagementTab", value.toString());
    getAllPspConfigs(
      (pspdata) => {
        getAllVisualizationFilterData(
          'payment_operations',
          // postPspConfigForFiltering(
          { attributeFilters: { operationName: FIXED_OPERATION_NAME } },
          function (data) {
            let schema = filterAllSchema;
            if (value === 1) {
              schema = filterRefundSchema;
            }
            if (value === 2) {
              schema = filterVoidSchema;
            }
            let idx = data?.operations?.findIndex(
              (item) => item?.value === "Authorisation"
            );
            if (idx >= 0) {
              data.operations[idx].value = "Sale";
            }

            handleUpdateAllSchemaMethods(schema, data);
            const processorLOGO = pspdata.map((item) => item);
            setProcessorData(processorLOGO);

            // getAllPaymentMethods(function (methodData) {
            //   const merchantPaymentMethods = methodData.filter((item) =>
            //     data.paymentMethodIds.includes(item.id)
            //   );
            //   handleUpdateMethodsSchema(schema, merchantPaymentMethods);
            //   handleUpdatePaymentMethodsSchema(schema, merchantPaymentMethods);
            setLoading(false);
            // });
          },
          function (errorMsg) {
            customToast("error", "high", errorMsg);
          }
        );
      },
      (errorMsg) => {
        customToast("error", "high", errorMsg);
      }
    );
  }, [value]);

  useEffect(() => {
    getPaymentMethod(
      function (data) {
        setPaymentMethodData(data);
      },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
      }
    );

    merchantSettings(
      function (data) {
        setTimezone(data?.timeZone);
      },
      function (errorMsg) {
        customToast("error", "high", errorMsg);
      }
    );
  }, []);

  const memoizedWithSearchbarModalData = useMemo(() => {
    return withSearchbarModalData
  }, [withSearchbarModalData])
  const memoizedDateModalData = useMemo(() => dateModalData, [dateModalData]);

  useEffect(() => {
    if (timezone && value === 0) {
      getFilterData(attributeName, attributeValue);
    }
  }, [timezone, memoizedWithSearchbarModalData, memoizedDateModalData, pageNo, pageLimit]);

  const memoisedSearchbarModalDataForRefund = useMemo(() => withSearchbarModalDataForRefund, [withSearchbarModalDataForRefund])
  const memoisedDateModalDataForRefund = useMemo(() => dateModalDataForRefund, [dateModalDataForRefund])
  useEffect(() => {
    if (timezone && value === 1) {
      getRefundDataSearch("", "");
    }
  }, [timezone, memoisedSearchbarModalDataForRefund, memoisedDateModalDataForRefund, pageNo, pageLimit]);

  function getFilterData(attrName, values) {
    setLoader(true)
    setAttributeName(attrName);
    setAttributeValue(values);
    let search = [];
    if (Array.isArray(values) || values?.length > 0) {
      const storedOrderSearch = JSON.parse(localStorage.getItem("OrderSearch"));
      const orderSearch = {
        attrName: attrName,
        operator: "containsIgnoreCase",
        values: [values],
      }
      search.push(storedOrderSearch ? storedOrderSearch : orderSearch);
    }
    let filters = {};
    withSearchbarModalData.forEach((item) => {
      filters[item.id] = item.value;
    });

    const currentDate = new Date();
    let fromDate, toDate;

    if (dateModalData?.selectedValue) {
      const { fromDate: formattedFromDate, toDate: formattedToDate } =
        fortmatTimezoneToUTC(
          dateModalData?.selectedValue,
          dateModalData?.finalStartDate,
          dateModalData?.finalEndDate
        );
      fromDate = formattedFromDate;
      toDate = formattedToDate;
    } else {
      const currentYear = currentDate.getFullYear();
      toDate = new Date();
      toDate.setHours(23, 59, 59, 999);
      fromDate = new Date(toDate);
      fromDate.setMonth(fromDate.getMonth() - 13);
      fromDate.setHours(0, 0, 0, 0);
    }
    let reqData = {
      fromDate: fromDate,
      toDate: toDate,
      attributeFilters: { ...filters, operationName: FIXED_OPERATION_NAME },
      advancedAttributeFilters: search,
      limit: pageLimit, // pagination
      offset: (pageNo - 1) * pageLimit // pagination
    };

    setFilters(reqData);
    if (timezone) {
      getAllTransactionDetails(reqData, function (paymentData) {
        const filterData = paymentData.points.map((rawData) => {
          if (!rawData?.paymentMethodType && rawData?.emiMethod) {
            rawData.paymentMethodType = "Emi";
            rawData.paymentMethodTypeLocale = "EMI";
          }
          return rawData;
        });

        setFilterApiData(filterData);
        setLoader(false);
        setLoading(false);
        setTotalDataCount(paymentData.totalCount);// pagination
      },
        function (errorMsg) {
          setPaymentError(errorMsg);
        },
        operationPermissions
      );
    }
  }

  function getRefundDataSearch(attrName, values) {
    if (attrName === "name") {
      attrName = "shopper.firstName";
    }
    if (attrName === "mobileNumber") {
      attrName = "shopper.phoneNumber";
    }
    if (attrName === "email") {
      attrName = "shopper.email";
    }
    let search = [];
    if (Array.isArray(values) || values?.length > 0) {
      search.push({
        attrName: attrName,
        operator: "containsIgnoreCase",
        values: [values],
      });
    }

    let filters = {};

    withSearchbarModalDataForRefund.forEach((item) => {
      filters[item.id] = item.value;
    });

    const currentDate = new Date();
    let fromDate, toDate;

    if (dateModalDataForRefund?.selectedValue) {
      const { fromDate: formattedFromDate, toDate: formattedToDate } =
        fortmatTimezoneToUTC(
          dateModalDataForRefund?.selectedValue,
          dateModalDataForRefund?.finalStartDate,
          dateModalDataForRefund?.finalEndDate
        );
      fromDate = formattedFromDate;
      toDate = formattedToDate;
    } else {
      const currentYear = currentDate.getFullYear();
      toDate = new Date();
      toDate.setHours(23, 59, 59, 999);
      fromDate = new Date(toDate);
      fromDate.setMonth(fromDate.getMonth() - 13);
      fromDate.setHours(0, 0, 0, 0);
    }

    const attributeFilters = {
      ...filters,
      operationName: ["Refund", "Partial_Refund"],
    };

    getRefundData(
      {
        fromDate: fromDate,
        toDate: toDate,
        attributeFilters,
        advancedAttributeFilters: search,
        limit: pageLimit, // pagination
        offset: (pageNo - 1) * pageLimit // pagination
      },
      (refundAPIData) => {
        const filterData = refundAPIData.points.map((rawData) => {
          if (!rawData?.paymentMethodType && rawData?.emiMethod) {
            rawData.paymentMethodType = "Emi";
            rawData.paymentMethodTypeLocale = "EMI";
          }
          return rawData;
        });
        setRefundData(filterData);
        setLoaderForRefund(false);
        setLoader(false);
        setLoading(false);
        setTotalDataCount(refundAPIData.totalCount);// pagination
      },
      (errorMsg) => {
        setPaymentError(errorMsg);
      },
      operationPermissions
    );
  }

  function expandLogoDetails(transactionData) {
    return transactionData.map((item) => {
      item.operationName =
        item?.paymentType === "S" && item?.operationName === "Authorisation"
          ? "Sale"
          : item?.operationName;
      const filteredData = paymentMethodData.filter((paymentItem) =>
        item.paymentMethodSubType === paymentItem.brand
          ? paymentItem.logoUrl
          : ""
      );
      const filteredProcessorData = processorData.find(
        (processorItem) =>
          item?.pspCode === processorItem?.pspCode ||
          item?.pspCode === processorItem?.title
      );
      let expandedData = {
        ...item,
        pspCode:
          filteredProcessorData?.title === undefined
            ? item.pspCode
            : filteredProcessorData?.title,
        paymentMethodLogoUrl: item.paymentMethodLogoUrl || (filteredData?.length > 0 ? filteredData[0].logoUrl : ""),
        pspCodeLogoURL: filteredProcessorData
          ? filteredProcessorData.pspLogoUrl
          : "",
        categoryDataForSorting: {
          type: item?.paymentMethodType,
          subType: item?.paymentMethodSubType,
        },
      };
      return expandedData;
    });
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleSearchbarModalData = (data) => {
    if (value == 0) {
      setWithSearchbarModalData(data);
      // setLoader(true);
    } else {
      setLoaderForRefund(true);
      setWithSearchbarModalDataForRefund(data);
    }
  };

  const handleDateModalData = (data) => {
    if (value === 0) {
      setDateModalData(data);
    } else {
      setDateModalDataForRefund(data);
    }
  };

  const updateMethodsArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const updateAllPaymentMethodsArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const updateAllCurrencySchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const updateAllCountrySchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const updateAllPspSchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);

    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const updateAllOpterationSchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);
    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const updateAllBusinessUnitSchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);
    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const updateAllStatusSchemaArray = (schema, objectId, newArray) => {
    const newData = [...schema];
    const objectIndex = newData.findIndex((obj) => obj.id === objectId);
    if (objectIndex !== -1) {
      newData[objectIndex].items = newArray;
    }
  };
  const handleUpdateAllSchemaMethods = (schema, allModalData) => {
    const objectCurrencyIdToUpdate = "currencyCode";
    // updateAllCurrencySchemaArray(
    //   schema,
    //   objectCurrencyIdToUpdate,
    //   allModalData.currencyCodes
    // );
    // const objectCountryIdToUpdate = "countryCode";
    // updateAllCountrySchemaArray(
    //   schema,
    //   objectCountryIdToUpdate,
    //   allModalData.countryCodes
    // );
    const objectPspIdToUpdate = "pspCode";
    let pspCodeData = allModalData.find(d => d.filterName === objectPspIdToUpdate);
    updateAllPspSchemaArray(schema, objectPspIdToUpdate, pspCodeData?.filterValues || []);
    // updateAllPspSchemaArray(schema, objectPspIdToUpdate, allModalData?.operations.pspCode);

    const objectOperationIdToUpdate = "operationName";
    let operationNameData = allModalData.find(d => d.filterName === objectOperationIdToUpdate);
    updateAllOpterationSchemaArray(schema, objectOperationIdToUpdate, operationNameData?.filterValues || []);

    const objectBusinessUnitIdToUpdate = "legalEntity";
    let legalEntityData = allModalData.find(d => d.filterName === objectBusinessUnitIdToUpdate);
    updateAllBusinessUnitSchemaArray(schema, objectBusinessUnitIdToUpdate, legalEntityData?.filterValues || []);

    const objectpaymentMethodTypeToUpdate = "paymentMethodType";
    let paymentMethodTypeData = allModalData.find(d => d.filterName === objectpaymentMethodTypeToUpdate);
    updateMethodsArray(schema, objectpaymentMethodTypeToUpdate, paymentMethodTypeData?.filterValues || []);

    const objectpaymentMethodSubTypeToUpdate = "paymentMethodSubType";
    let paymentMethodSubTypeData = allModalData.find(d => d.filterName === objectpaymentMethodSubTypeToUpdate);
    updateAllPaymentMethodsArray(schema, objectpaymentMethodSubTypeToUpdate, paymentMethodSubTypeData?.filterValues || []);

    const finalStatusToUpdate = "finalStatus";
    let finalStatusData = allModalData.find(d => d.filterName === finalStatusToUpdate);
    updateAllStatusSchemaArray(schema, finalStatusToUpdate, finalStatusData?.filterValues || []);
  };
  const handleSearchData = (attributeName, inputValue) => {

    setPageNo(1) // pagination
    const prevVal = transactionCurrentSearchAttribute?.current
    transactionCurrentSearchAttribute.current = { key: attributeName, value: inputValue || "" }
    if (prevVal.key !== attributeName && prevVal?.value == inputValue) return
    // setLoader(true);
    getFilterData(attributeName, inputValue);
  };
  const handleRefundSearchData = (attributeName, inputValue) => {
    setPageNo(1)
    const prevVal = refundCurrentSearchAttribute?.current
    refundCurrentSearchAttribute.current = { key: attributeName, value: inputValue || "" }
    if (prevVal.key !== attributeName && prevVal?.value == inputValue) return
    // setLoaderForRefund(true);
    getRefundDataSearch(attributeName, inputValue);
  };
  useEffect(() => {
    getAllModalData(
      function (data) {
        setBusinessUnitData(data?.legalEntities);
      },
      function (errorMsg) { }
    );
  }, []);
  useEffect(() => {
    if (businessUnitData?.length) {
      const transactions = filterApiData?.map((transactions) => {
        const businessUnit = businessUnitData?.find(
          (unit) => unit?.code === transactions?.legalEntity
        );

        return {
          ...transactions,
          legalEntity: businessUnit ? businessUnit.name : null,
        };
      });
      setFormattedApiData(transactions)
    }
  }, [filterApiData, businessUnitData])



  return (
    <>
      {loading ? (
        <LoadingLogoPage />
      ) : (
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section className="content">
            <Box sx={{ width: "100%" }}>
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  width: "200px",
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  TabIndicatorProps={{
                    sx: {
                      background: colorBrandObject?.primaryButtonColor,
                      height: 2,
                    },
                  }}
                >
                  <Tab
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      fontWeight: 600,
                      textTransform: "none",
                      color: `${colorBrandObject?.primaryButtonColor} !important`
                    }}
                    label="All"
                  />
                  <Tab
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: "16px",
                      fontWeight: 600,
                      textTransform: "none",
                      color: `${colorBrandObject?.primaryButtonColor} !important`
                    }}
                    label="Refunds"
                  />
                </Tabs>
              </Box>
            </Box>
            <Box style={{ width: "100%" }}>
              <TabPanel value={value} index={0} className="orderManagement">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <InputSearch searchData={handleSearchData} />
                  </div>
                  <div
                    style={{
                      width: "30%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <AllTransactionButton
                      setLoading={setLoading}
                      filterApiData={filterApiData}
                      attributeName={attributeName}
                      attributeValue={attributeValue}
                    />
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: "32px" }}>
                  <Filter
                    value={value}
                    filteredSchema={filterAllSchema}
                    handleSearchbarModalData={handleSearchbarModalData}
                    handleDateModalData={handleDateModalData}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "24px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {/* pagination */}
                  <BoxPayGrid
                    schema={allTransactionschema(operationPermissions)}
                    data={expandLogoDetails(formattedApiData)}
                    loader={loader}
                    customPagination={true}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    totalDataCount={totalDataCount}
                  />
                  {/* pagination */}
                </div>
              </TabPanel>
              <TabPanel value={value} index={1} className="orderManagement">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "70%" }}>
                    <InputSearchRefund searchData={handleRefundSearchData} />
                  </div>
                </div>
                <div style={{ display: "flex", marginTop: "32px" }}>
                  <Filter
                    value={value}
                    filteredSchema={filterRefundSchema}
                    handleSearchbarModalData={handleSearchbarModalData}
                    handleDateModalData={handleDateModalData}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    marginTop: "24px",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >

                  <BoxPayGrid
                    schema={refundSchema}
                    loader={loaderForRefund}
                    data={expandLogoDetails(refundData)}
                    customPagination={true}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    pageLimit={pageLimit}
                    setPageLimit={setPageLimit}
                    totalDataCount={totalDataCount}
                  />

                </div>
              </TabPanel>
            </Box>
          </section>
        </div>
      )}
    </>
  );
}

export default Transactions;
